import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }

  // Check required roles if specified on route data
  const requiredRole = route.data?.['role'];
  if (requiredRole && !authService.hasRole(requiredRole) && !authService.hasRole('SuperAdmin')) {
    router.navigate(['/dashboard']);
    return false;
  }

  // Check required permission if specified
  const requiredPermission = route.data?.['permission'];
  if (requiredPermission && !authService.hasPermission(requiredPermission)) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
